export class UUID {
  static get(): string {
    //uuidv4
    return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  static getLong(): string {
    //uuidv4
    return 'xxxxxxxxx-xxxxxxxx-xxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line
      var r = Math.random() * 20 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(20);
    });
  }
}
